import api from "./axios";

export const getSprints = (projectId) =>
  api.get(`/sprints${projectId ? `?projectId=${projectId}` : ""}`);
export const createSprint = (data) => api.post("/sprints", data);
export const editSprint = (id, data) => api.put(`/sprints/${id}`, data);
export const deleteSprint = (id, deleteIssues = false) => 
  api.delete(`/sprints/${id}${deleteIssues ? '?deleteIssues=true' : ''}`);
export const updateSprintStatus = (id, status, force = false) => api.put(`/sprints/${id}/status`, { status, force });
/**
 * Set a status outright, skipping the forward-only lifecycle guards — used by
 * the Edit Sprint form so a manager can reopen a completed sprint. The board's
 * Start / Complete / Release buttons deliberately keep using the guarded call
 * above, so a stray click still cannot skip a step.
 */
export const overrideSprintStatus = (id, status) =>
  api.put(`/sprints/${id}/status`, { status, force: true, override: true });
export const getSprintBoard = (id) => api.get(`/sprints/${id}/board`);
/** Kanban-shaped payload (same as getSprintBoard) for issues with no sprint in this project. */
export const getProjectBacklogBoard = (projectId) =>
  api.get(`/sprints/backlog/board`, { params: { projectId } });
export const getBacklog = (projectId) =>
  api.get(`/sprints/backlog${projectId ? `?projectId=${projectId}` : ""}`);
export const getBurndown = (id) => api.get(`/sprints/${id}/burndown`);
export const releaseSprint = (id, data) => api.post(`/sprints/${id}/release`, data);
export const getReleases = (projectId) =>
  api.get(`/sprints/releases${projectId ? `?projectId=${projectId}` : ""}`);
export const moveIssueToSprint = (issueId, sprint_id) =>
  api.put(`/issues/${issueId}/move-to-sprint`, { sprint_id });
